// extracted by css-extract-rspack-plugin
var _1 = "ZiYBmRCwC5wdHrFr";
var _2 = "DiBXgbwDCZ4Fc5e8";
var _3 = "D3kJB3C0dZUh_8eK";
export { _1 as "bottom", _2 as "center", _3 as "top" }
